// extracted by css-extract-rspack-plugin
var _1 = "JQHEI36UY5lT2pdZ";
var _2 = "_hdW4P9jvY7I1Dng";
var _3 = "DTVoFbkB7f0ohZKQ";
var _4 = "GJMq2nes1UgQmSWs";
export { _1 as "countdown", _2 as "logo", _3 as "match", _4 as "title" }
